import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import type { ApplyV2TempReference } from '@core/app/types/applyV2Type'
import formatPhoneNumber from '@core/utils/helpers/formatPhoneNumber'
import clsx from 'clsx'
import React from 'react'
import './ApplyV2ReviewApplyReference.scss'
import { useTranslation } from 'react-i18next'

const baseClass = 'ApplyV2ReviewApplyReference'

interface ApplyV2ReviewApplyReferenceProps {
    className?: string
    isShowExpandButton?: boolean
}

function ApplyV2ReviewApplyReference({ className = '' }: ApplyV2ReviewApplyReferenceProps) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const data = postProfileData?.data?.reference || []
    const isEmpty = data.length === 0

    return (
        <div
            className={clsx(baseClass, className, {
                [`${baseClass}--isEmpty`]: isEmpty,
            })}
        >
            {isEmpty ? (
                <div>{t('10705', 'No references added')}</div>
            ) : (
                data.map((ref) => <ApplyV2ReviewApplyReferenceItem key={ref.uid || ref.existingId} {...ref} />)
            )}
        </div>
    )
}

function ApplyV2ReviewApplyReferenceItem({
    name,
    title,
    companyName,
    email,
    mobilePhone,
    description,
}: ApplyV2TempReference) {
    return (
        <div className={`${baseClass}__item`}>
            <div className={`${baseClass}__item--name`}>{name}</div>
            <div className={`${baseClass}__item--position`}>
                {title && <span className={`${baseClass}__item--position-title`}>{title}</span>}
                {title && companyName && <span className={`${baseClass}__item--position-dot`}></span>}
                {companyName && <span className={`${baseClass}__item--position-role`}>{companyName}</span>}
            </div>
            {(mobilePhone?.prefix || mobilePhone?.number) && (
                <ApplyV2DataRow fieldType={'tel'} className={`${baseClass}__item--mobilePhone`}>
                    {formatPhoneNumber(mobilePhone)}
                </ApplyV2DataRow>
            )}
            {email && (
                <ApplyV2DataRow fieldType={'email'} className={`${baseClass}__item--email`}>
                    {email}
                </ApplyV2DataRow>
            )}
            {description && <div className={`${baseClass}__item--description`}>{description}</div>}
        </div>
    )
}

export default ApplyV2ReviewApplyReference
